import React from "react";

const TextField = ({
  type = "text",
  name,
  placeholder = "",
  value = "",
  onChange = () => {},
  className = "",
  ...props
}) => {
  return (
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`w-full box-border py-[15px] px-[18px] rounded-[14px] border border-border-input bg-surface-card text-[15px] text-text-dark outline-none  focus:border-brand-purple focus:bg-white ${className}`}
      {...props}
    />
  );
};

export default TextField;
